<template>
  <historical-bookings />
</template>

<script>
import HistoricalBookings from "@/components/Ondemand/Bookings/HistoricalBookings";
export default {
  components: {
    HistoricalBookings,
  },
};
</script>

<style></style>
